import { render, staticRenderFns } from "./SecretCards.vue?vue&type=template&id=270c08a0&scoped=true&"
import script from "./SecretCards.vue?vue&type=script&lang=js&"
export * from "./SecretCards.vue?vue&type=script&lang=js&"
import style0 from "./SecretCards.vue?vue&type=style&index=0&id=270c08a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c08a0",
  null
  
)

export default component.exports